import React from 'react';
import {r} from "@/utils/responsive";
import sharePanelBg from "@/assets/img/share_panel_bg.png"
import DisabledWrapper from "@/components/DisabledWrapper";
import bgCardVideo from "@/assets/video/bg_card_video.mp4";
import QRCodeImage from "@/assets/img/yc_qr.png"
import ReactPlayerWrapper from "@/components/ReactPlayerWrapper";
import {S3_FILES} from "@/config/s3_files";
import {useNav} from "@/hooks/useNav";
import {motion} from "motion/react"

interface SharePanelProps extends React.HTMLAttributes<HTMLDivElement> {
}

const SharePanel: React.FC<SharePanelProps> = ({className, ...props}) => {
    const {currentSection} = useNav()
    return (
        <motion.div
            initial={{
                opacity: 0,
                translateX: 80,
            }}
            animate={{
                opacity: currentSection === 'share' ? 1 : 0,
                translateX: currentSection === 'share' ? 0 : 40,
            }}
            transition={{
                duration: .5
            }}
            style={{
                width: r.vmax(637),
                height: r.vmax(660),
                position: 'fixed',
                top: r.vmax(173),
                right: r.vmax(412),
                whiteSpace: 'pre-wrap',
                padding: `${r.vmax(68)} ${r.vmax(44)} ${r.vmax(38)}`,
                color: 'white',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                ...props.style
            }}
        >
            <svg style={{position: 'absolute', width: 0, height: 0}}>
                <defs>
                    <clipPath id="share_video_mask" clipPathUnits="objectBoundingBox">
                        <path
                            d="M0 0.121C0 0.064 0 0.036 0.018 0.018C0.037 0 0.066 0 0.126 0H0.164C0.176 0 0.182 0 0.188 0.001C0.194 0.002 0.200 0.004 0.211 0.009L0.252 0.025C0.263 0.029 0.269 0.031 0.275 0.033C0.281 0.034 0.287 0.034 0.299 0.034H0.708C0.718 0.034 0.723 0.034 0.729 0.033C0.734 0.032 0.739 0.030 0.748 0.027L0.761 0.023C0.771 0.020 0.776 0.018 0.781 0.018C0.786 0.017 0.791 0.017 0.801 0.017H0.875C0.934 0.017 0.963 0.017 0.983 0.035C1 0.052 1 0.081 1 0.138V0.842C1 0.899 1 0.928 0.983 0.946C0.963 0.963 0.934 0.963 0.875 0.963H0.862C0.849 0.963 0.842 0.963 0.835 0.964C0.829 0.965 0.823 0.968 0.811 0.973L0.798 0.979C0.774 0.989 0.761 0.995 0.749 0.997C0.736 1 0.723 1 0.696 1H0.126C0.066 1 0.037 1 0.018 0.982C0 0.964 0 0.936 0 0.879V0.121Z"
                        />
                    </clipPath>
                </defs>
            </svg>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: r.vmax(24),
                fontSize: r.vmax(28),
                lineHeight: r.vmax(36),
                // paddingLeft: r.vmax(24),
            }}>
                <p>{`Миссия завершена.\nНо помните: Kubernetes® — не цель. \nЭто путь.`}</p>
                <p>{`И если однажды вы услышите \nтревожный лог или увидите \nCrashLoopBackOff в тишине ночи — \nзнайте: Контейнерленд всегда будет \nнуждаться в K8sKeeper, а Yandex \nManaged Service for Kubernetes® \nпоможет в поддержании баланса.`}</p>
            </div>
            <div style={{
                position: 'relative',
                height: r.vmax(100),
                gap: r.vmax(20),
                fontSize: r.vmax(20),
                lineHeight: r.vmax(24),
                paddingLeft: r.vmax(107),
                marginLeft: r.vmax(20),
                display: 'flex',
                alignItems: 'center',
                width: r.vmax(433),
                borderRadius: r.vmax(20),
                background: 'rgba(0, 31, 97, 0.5)',
                boxShadow: `inset 0px 0px 50px #5C93FF`
            }}>
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: r.vmax(-42),
                    display: 'flex',
                    transform: 'translateY(-50%)',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: r.vmax(132),
                    height: r.vmax(132),
                    borderRadius: r.vmax(23),
                    backgroundColor: '#4677F6',
                    padding: r.vmax(20),
                    boxShadow: `0px 7.5641px 30.2564px #5588FF, inset 0px -19.6667px 25.7179px rgba(255, 255, 255, 0.32), inset 0px 3.78205px 32px -3.60101px #FFFFFF, inset 0px -19.6667px 43.8718px -24.3068px #5282FF, inset 0px -18.005px 15.1242px -6.30176px #1741B1`
                }}>
                    <img src={QRCodeImage} style={{
                        pointerEvents: 'none',
                        userSelect: 'none',
                        width: '100%',
                        height: '100%',
                    }} alt=""/>
                </div>
                <p>{`Присоединяйтесь к сообществу \nединомышленников`}</p>
            </div>
            <div style={{
                position: 'absolute',
                inset: 0,
                zIndex: -1,
                clipPath: 'url(#share_video_mask)',
                backdropFilter: 'blur(44px)',
            }}>
                <DisabledWrapper>
                    <img src={sharePanelBg} alt=""
                         style={{width: '100%', height: '100%', position: 'relative', zIndex: 1}}/>
                    <div style={{
                        position: 'absolute',
                        inset: 0,
                        width: '100%', height: '100%',
                    }}>
                        <ReactPlayerWrapper style={{
                            position: 'absolute',
                            inset: 0,
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            objectPosition: 'center',
                            zIndex: -1,
                            mixBlendMode: 'color-dodge',
                            opacity: .5
                        }} videoSrc={S3_FILES.CHARACTER_CARD_BG_VIDEO}
                                            posterSrc={S3_FILES.CHARACTER_CARD_BG_VIDEO_POSTER}/>
                    </div>
                </DisabledWrapper>
            </div>
        </motion.div>
    );
};

export default SharePanel;
